import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ReturnSelling from "../../../containers/modules/sales/return-selling";

export default function ReturnSellingRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="return-selling"
      index
      element={
        <AccessControl
          name={"Return Selling List"}
          auth={authUser}
          component={() => <ReturnSelling />}
        />
      }
    />
  );
}
